import style from './style.css';

const ProductCard = ({ productDetails }) => {
  const {
    productImage,
    merchantLogo,
    productName,
    tenure,
    isNoCost,
  } = productDetails;
  return (
    <div className={style.productCardContainer}>
      <div>
        <img
          className={style.productImageStyle}
          src={productImage}
          alt='product image'
        />
      </div>
      <div className={style.rightContainer}>
        <div>
          <img
            className={style.merchantLogo}
            src={merchantLogo}
            alt='zebrs logo'
          />
        </div>
        <div>
          <div className={style.productName}>{productName}</div>
          <div className={style.seperator} />
          <div className={style.tenure}>{tenure}</div>
        </div>
        {isNoCost && <div className={style.tag}>NO COST EMI*</div>}
      </div>
    </div>
  );
};

export default ProductCard;



// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVMerchant/productCard/index.js